import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as Options from '../../work-orders/select-options';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ContactAutocompleteService, ContactAutocompleteResult} from '../../services/contacts/contact-autocomplete.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalClosedSource = new Subject<void>();

  modalClosed$ = this.modalClosedSource.asObservable();

  closeModal(): void {
    this.modalClosedSource.next();
  }
}

@Component({
  selector: 'app-shipment-lists-modal',
  templateUrl: './shipment-lists-modal.component.html',
  styleUrls: ['./shipment-lists-modal.component.scss']
})
export class ShipmentListsModalComponent implements OnInit {

  modalTitle: string;
  modalMessage: any;
  shipmentForm!: FormGroup;
  editShipmentForm!: FormGroup;
  editTripShipmentForm!: FormGroup;
  palletForm!: FormGroup;
  multiplepalletsForm!: FormGroup;
  servicesForm!: FormGroup;
  editPalletForm!: FormGroup;
  serviceForm!: FormGroup;
  deleteTripForm!: FormGroup;
  deleteBarcodeForm!: FormGroup;
  deletePalletForm!: FormGroup;
  deleteServiceRateForm!: FormGroup;
  uploadFileForm!: FormGroup;
  uploadYoshinoForm!: FormGroup;
  uploadInventoryFileForm!: FormGroup;
  editTripDetailsForm!: FormGroup;
  moveExceptionCartonForm!: FormGroup;
  printBOLForm!: FormGroup;  
  createEDIFileForm!: FormGroup; 

  statuses: string[] = [
    "",
    "MANUAL AUDIT",
    "MISSING",
    "OVERAGE",
    "OPENED",
    "BROKEN",
    "CRUSHED",
    "WET",
    "HOLDOVER"
  ];
  asn_array!: any[];
  store_array!: any[];
  shipper_array!: any[];
  week_array: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ShipmentListsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private modalService: ModalService, 
    private contactSvc: ContactAutocompleteService
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;

    this.shipmentForm = this.fb.group({
      service: [''],
      flat_rate: [''],
      load_no: [''],
    });

    this.servicesForm = this.fb.group({
      service: this.modalMessage.service,
      service_type: this.modalMessage.service_type,
      flat_rate: this.modalMessage.flat_rate,
    });

    this.editPalletForm = this.fb.group({
      package_uuid: this.modalMessage.package_uuid,
      carton_count: this.modalMessage.cartons_pallet,
      dimension_height: this.modalMessage.height,
      dimension_length: this.modalMessage.length,
      dimension_width: this.modalMessage.width,
      load_no: this.modalMessage.load_no,
    });

    this.palletForm = this.fb.group({
      carton_count: [''],
      dimension_height: [''],
      dimension_length: [''],
      dimension_width: [''],
      load_weight: [''],
      load_no: [''],
    });


    this.editTripShipmentForm = this.fb.group({
      shipment_list_uuid: this.modalMessage.shipment_list_uuid,      
      act_trail_number: this.modalMessage.act_trail_number,      
      external_bill_of_lading: this.modalMessage.external_bill_of_lading
    });

    this.multiplepalletsForm = this.fb.group({
      no_of_pallets: [''],
      dimension_height: [''],
      dimension_length: [''],
      dimension_width: [''],
      carton_weight: [''],
      total_weight: [''],
      load_no: [''],
    });

    this.serviceForm = this.fb.group({
      service_rate_service: [''],
      service_rate_service_type: [''],
      flat_rate: [''],
    });

    this.uploadFileForm = this.fb.group({
      customer: [''],
      week_no: [''],
      file_type: [''],
      store_number: [''],
      manifest_carton_count: [''],
      bol_carton_count: [''],
      asn_number: [''],
      trailer_id: [''],
      drop_trailer_alternate_reference: [''],
      distribution_center_contact_uuid: [''],
    });

    this.uploadYoshinoForm = this.fb.group({
    });

    this.uploadInventoryFileForm = this.fb.group({
      inventory_warehouse_uuid: this.modalMessage.inventory_warehouse_uuid,
    });

    this.deleteTripForm = this.fb.group({
      trip_list_uuid: this.modalMessage.trip_list_uuid,
      asn_number: this.modalMessage.asn_number,
      trip_number: this.modalMessage.trip_number,      
    });       

    this.deleteBarcodeForm = this.fb.group({
      barcode: this.modalMessage.barcode,
      product_uuid: this.modalMessage.uuid,
    });       


    this.deletePalletForm = this.fb.group({
      count: this.modalMessage.count,
      package_uuid: this.modalMessage.uuid,
    });       

    this.deleteServiceRateForm = this.fb.group({
      service: this.modalMessage.service,
      service_type: this.modalMessage.service_type,
      contact_profile_default_service_uuid: this.modalMessage.contact_profile_default_service_uuid,
    });         

    this.editTripDetailsForm = this.fb.group({
      trip_list_uuid: this.modalMessage.trip_list_uuid,
      week_no: this.modalMessage.shipment?.details?.week_no,
      manifest_carton_count: this.modalMessage.manifest_carton_count,
      bol_carton_count: this.modalMessage.bol_carton_count,
      trip_number: this.modalMessage.trip_number,
      asn_number: this.modalMessage.asn_number,
    });    

    this.moveExceptionCartonForm = this.fb.group({
      product_uuid: this.modalMessage.product_uuid,
      barcode: this.modalMessage.barcode,
      trip_number: this.modalMessage.trip_number,
      asn_number: this.modalMessage.asn_number,
      store_number: this.modalMessage.store_number,      
    });      

    this.createEDIFileForm = this.fb.group({
      lading_uuid: this.modalMessage.lading_uuid,
      alternate_reference: this.modalMessage.alternate_reference,
    });   

    if (this.modalTitle == 'Print Bill Of Lading')
    {
      this.printBOLForm = this.fb.group(
        {
          uuid: this.modalMessage.lading_uuid,
          alternate_reference: this.modalMessage.alternate_reference,
          shipper_contact_uuid: this.modalMessage.shipper_contact_uuid,
          page_no: '1',
        }
      );        
    }
    if (this.modalTitle == 'Edit Shipment Details')
    {
      this.editShipmentForm = this.fb.group(
        {
          asn_number: this.modalMessage.shipment?.details?.asn_number,
          store_number: this.modalMessage.shipment?.details?.store_number,
          appointment_day: this.modalMessage.shipment?.operation?.appointment_day,
          appointment_start: this.modalMessage.shipment?.operation?.appointment_start,
          appointment_end: this.modalMessage.shipment?.operation?.appointment_end,
          express_road: [''],
          carbon_fuel_tax: [''],
          carrier_contact_uuid: this.modalMessage.shipment?.carrier?.contact_organization,
          external_bill_of_lading: this.modalMessage.shipment?.details?.external_bill_of_lading,
          total_cartons: this.modalMessage.shipment?.details?.total_cartons,
          reported_weight: this.modalMessage.shipment?.details?.reported_weight,
          customerContactUuid: [''],
          customerContactName: [''],
        }
      );
    }    
  }
  pallets: any[] = [1, 2];
  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    const url = '/api/shipment_lists/shipment_details.php';
    this.http.get<any>(url).subscribe((response: any) => {
      this.asn_array = response.data.asn_number;
    });
    const storeUrl = '/api/shipment_lists/shipment_trip_lists.php';
    this.http.get<any>(storeUrl, { params: { store: 'spencer gifts' } }).subscribe((response: any) => {
      this.store_array = response.stores.map((item: any) => {
        const parts = item.contact_organization.split('#');
        return parts[1];
      });
    });
    let counter = 0;
    if (Array.isArray(this.modalMessage.pallets)) {
      this.pallets = this.modalMessage.pallets?.map((item: any) => {
        counter += 1;
        return { id: item.package_uuid, value: 'Pallet ' + counter + ': Cartons: ' + item.cartons_pallet + ' Dimensions: ' + item.height + 'x' + item.length + 'x' + item.width }
      })
    }
    this.week_array.push('No Change')
    for (let i = 1; i <= 52; i++) {
      this.week_array.push(i);
    }

    if (this.modalTitle == 'Print Bill Of Lading')
    {
      const shipperURL = '/api/shipment_lists/shipment_print_shipper.php';
    
      this.http.get<any>(shipperURL, { params: { alternate_reference: this.modalMessage.alternate_reference } }).subscribe((response: any) => {
        this.shipper_array = response.data;
      });

    }
    if (this.modalTitle == 'Edit Shipment Details')
    {
      this.editShipmentForm = this.fb.group(
        {
          asn_number: this.modalMessage.shipment?.details?.asn_number,
          store_number: this.modalMessage.shipment?.details?.store_number,
          appointment_day: this.modalMessage.shipment?.operation?.appointment_day,
          appointment_start: this.modalMessage.shipment?.operation?.appointment_start,
          appointment_end: this.modalMessage.shipment?.operation?.appointment_end,
          express_road: [''],
          carbon_fuel_tax: [''],
          carrier_contact_uuid: this.modalMessage.shipment?.carrier?.contact_organization,
          external_bill_of_lading: this.modalMessage.shipment?.details?.external_bill_of_lading,
          total_cartons: this.modalMessage.shipment?.details?.total_cartons,
          reported_weight: this.modalMessage.shipment?.details?.reported_weight,
          customerContactUuid: [''],
          customerContactName: [''],
        }
      );
    }
  }

  // Contact selection
  onCustomerSelected(opt: ContactAutocompleteResult): void {
      this.editShipmentForm.patchValue({
        customerContactUuid: opt.value,
        customerContactName: opt.label
      });
  
  }
  
  get customerNameControl(): FormControl {
    return this.editShipmentForm.get('customerContactName') as FormControl;
  }

  createService() {
    const add_service_rate_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=ADD_SERVICE_RATE`;

    var postData = this.serviceForm.value;
    postData = { ...postData, consignee_contact_uuid: this.modalMessage }

    console.log('Post Data:', postData);

    return this.http.post<any>(add_service_rate_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You created new Service successfully.'); 
        this.closeModal();
        window.location.reload();    
      })
  }

  getServices() {
    return Options.SERVICES;
  }

  getServiceType(service: string): string[] {
    let serviceTypes = [''];

    if (service === 'Service Program') {
      serviceTypes = Options.SERVICE_PROGRAM;
    }
    else if (service === 'Accessorial Service') {
      serviceTypes = Options.ACCESSORIAL_TYPE;
    }
    else if (service === 'Surcharge Service') {
      serviceTypes = Options.SURCHARGE_TYPE;
    }
    else if (service === 'Tradeshow Service') {
      serviceTypes = Options.TRADESHOW_TYPE;
    }
    else if (service === 'Trailer Build Service') {
      serviceTypes = Options.TRAILER_BUILD_TYPE;
    }
    else if (service === 'Suncor Service') {
      serviceTypes = Options.SUNCOR_TYPE;
    }
    else if (service === 'Customs Service') {
      serviceTypes = Options.CUSTOMS_TYPE;
    }
    else if (service === 'Delivery Service') {
      serviceTypes = Options.DELIVERY_TYPE;
    }
    else if (service === 'Pickup Service') {
      serviceTypes = Options.PICKUP_TYPE;
    }
    else if (service === 'Labourer Service') {
      serviceTypes = Options.LABOURER_TYPE;
    }
    else {
      serviceTypes = [];
    }

    return serviceTypes;
  }

  editShipment() {
    const edit_shipment_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_SHIPMENT_DETAILS`;
    //const update_shipment_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=SHIPMENT_UPDATE`;

    const shipmentObj = this.editShipmentForm.value;

    var postData = {
      ...shipmentObj,
      shipment_list_uuid: this.modalMessage.uuid,
      update: 1,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(edit_shipment_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
          this.toastr.success('You edited shipment successfully.'); 
          this.closeModal();
      })
  }

  editTripShipment() {
    const edit_shipment_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_TRIP_SHIPMENT_DETAILS`;

    const shipmentObj = this.editTripShipmentForm.value;

    var postData = {
      ...shipmentObj,
      shipment_list_uuid: this.modalMessage.shipment_list_uuid,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(edit_shipment_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You edited shipment successfully.'); 
        this.closeModal();
        window.location.reload();          
      })
  }

  submitNewPallet(): void {
    const formData = this.palletForm.value;
    formData.shipment_list_uuid = this.modalMessage.shipment_list_uuid;
    formData.trip_list_uuid = this.modalMessage.trip_list_uuid;

    const shipment_details_url = `/api/shipment_lists/shipment_details.php?uuid=${this.modalMessage.shipment_list_uuid}`;

    let url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=ADD_PACKAGE`;
    console.log('post data', formData)

    this.http.post<any>(url, formData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        this.toastr.success('You added new Pallet successfully.'); 
        this.closeModal();
        if (this.modalMessage.reload == 1)
        {
            window.location.reload();   
        }
        else
        {
          this.http.get<any>(shipment_details_url).subscribe(response => {

            console.log(response)
  
            this.pallets = response.pallets
  
          })
  
        }
      })


    console.log('Pallet Form', formData)
    console.log('Stringify:', JSON.stringify(formData))
  }

  submitMultiplePallets(): void {
    const formData = this.multiplepalletsForm.value;
    formData.shipment_list_uuid = this.modalMessage.shipment_list_uuid;
    formData.trip_list_uuid = this.modalMessage.trip_list_uuid;
    const shipment_details_url = `/api/shipment_lists/shipment_details.php?uuid=${this.modalMessage.shipment_list_uuid}`;

    let url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=ADD_MULTIPLE_PALLETS`;
    console.log('post data', formData)

    this.http.post<any>(url, formData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        this.toastr.success('You added new Pallets successfully.'); 
        this.closeModal();
        if (this.modalMessage.reload == 1)
          {
              window.location.reload();   
          }
          else
          {
            this.http.get<any>(shipment_details_url).subscribe(response => {
  
              console.log(response)
    
              this.pallets = response.pallets
    
            })
    
          } 
      })


    console.log('Pallet Form', formData)
    console.log('Stringify:', JSON.stringify(formData))
  }

  editServiceRate() {
    const edit_service_rate_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_SERVICE_RATE`;

    const servicesObj = this.servicesForm.value;

    var postData = {
      ...servicesObj,
      contact_profile_default_service_uuid: this.modalMessage.uuid,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(edit_service_rate_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.closeModal();
        this.toastr.success('You edited Service Rate successfully.'); 
        window.location.reload();    
      })
  }

  editPallet() {
    const edit_pallet_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=EDIT_PACKAGE`;
    const shipment_details_url = `/api/shipment_lists/shipment_details.php?uuid=${this.modalMessage.shipment_list_uuid}`;    

    const palletObj = this.editPalletForm.value;

    var postData = {
      ...palletObj
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(edit_pallet_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You edited Pallet successfully.'); 
        this.closeModal();
          if (this.modalMessage.reload == 1)
          {
              window.location.reload();   
          }
          else
          {
            this.http.get<any>(shipment_details_url).subscribe(response => {
  
              console.log(response)
    
              this.pallets = response.pallets
    
            })
    
          }        
      })
  }

  editTripDetails() {
    const edit_trip_details_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=TRIP_EDIT`;

    const tripDetailObj = this.editTripDetailsForm.value;

    var postData = {
      ...tripDetailObj
    }

    console.log('Post Data:', postData);
    
    return this.http.post<any>(edit_trip_details_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You edited Trip Details successfully.'); 
        this.closeModal();
              window.location.reload();   
   
      })
  }

  updateBarcodesPallets() {
    const update_barcode_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=SHIPMENT_UPDATE`;

      var postData = {
        shipment_list_uuid: this.modalMessage.shipment_list_uuid,
        alternate_reference: this.modalMessage.details?.alternate_reference,
        manifest_uuid: this.modalMessage.details?.manifest_uuid,
      }

      console.log('Post Data:', postData);
      console.log('Stringify:', JSON.stringify(postData))

      this.http.post<any>(update_barcode_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response);
          this.toastr.success('You Update the Work Orders Barcodes and Pallets successfully.'); 
          this.closeModal();
        })
  }
  pallet = new FormControl('');
  barcode = new FormControl('');
  return_status = new FormControl('');

  createBarcode() {
    var postData = {
      shipment_list_uuid: this.modalMessage.shipment_list_uuid,
      package_uuid: this.pallet.value,
      barcode: this.barcode.value,
    };

    let url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=ADD_BARCODE`;
    console.log('post data', postData)

    this.http.post<any>(url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        this.toastr.success('You created Barcode successfully.'); 
        this.closeModal();
        window.location.reload();            
      })

    console.log('Pallet Form', postData)
    console.log('Stringify:', JSON.stringify(postData))
  }

  changeBarcodeStatus() {
    var postData = {
      shipment_list_uuid: this.modalMessage.shipment_list_uuid,
      return_status: this.return_status.value,
    }

    const check_barcode_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=UPDATE_BARCODE_STATUS`;
    console.log('post data', postData)

    this.http.post<any>(check_barcode_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        this.toastr.success('You Updated the Barcodes Status successfully.'); 
        this.closeModal();
        window.location.reload();            
      })

    console.log('Pallet Form', postData)
    console.log('Stringify:', JSON.stringify(postData))
  }

  moveBarcodes() {
    const move_barcode_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=BARCODE_MOVE`;

      var postData = {
        shipment_list_uuid: this.modalMessage.shipment_list_uuid
      }

      this.http.post<any>(move_barcode_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response);
          this.toastr.success('You Moved the Unallocated Barcodes onto Pallets successfully.'); 
          this.closeModal();
          window.location.reload();    
        })
  }

  deleteTrip() {
    const delete_trip_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=DELETE_TRIP`;

    var postData = this.deleteTripForm.value;

    console.log('Post Data:', postData);

    return this.http.post<any>(delete_trip_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You deleted a Trip successfully.'); 
        this.closeModal();
        window.location.reload();        
      })
  }

  deletePallet() {
    const delete_pallet_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=DELETE_PACKAGE`;
    const shipment_details_url = `/api/shipment_lists/shipment_details.php?uuid=${this.modalMessage.shipment_list_uuid}`;       

    var postData = this.deletePalletForm.value;

    console.log('Post Data:', postData);

    return this.http.post<any>(delete_pallet_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        this.toastr.success('You deleted the Pallet successfully.'); 
        this.closeModal();
        if (this.modalMessage.reload == 1)
          {
              window.location.reload();   
          }
          else
          {
            this.http.get<any>(shipment_details_url).subscribe(response => {
  
              console.log(response)
    
              this.pallets = response.pallets
    
            })
    
          }  
      })
  }

  deleteRate() {
    const delete_service_rate_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=DELETE_SERVICE_RATE`;
    var postData = {
      contact_profile_default_service_uuid: this.modalMessage.uuid,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(delete_service_rate_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You deleted the Service Rate successfully.');
        this.closeModal();
        window.location.reload();    
      })
  }

  deleteBarcode() {
    const delete_barcode_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=DELETE_BARCODE`;

    var postData = this.deleteBarcodeForm.value;

    console.log('Post Data:', postData);

    return this.http.post<any>(delete_barcode_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You deleted Barcode successfully.'); 
        this.closeModal();
        window.location.reload();        
      })
  }

  @ViewChild('fileInput') fileInput!: ElementRef;

  selectFile() {
    this.fileInput.nativeElement.click();
  }

  formData: any = new FormData();;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    // const formData = new FormData();
    this.formData.append('file', file, file.name);
    console.log('original upload form', this.formData);
  }
  
  showSpinner = false;

  submitAsnFile() {
    console.log('UPLOAD TRIP');

    const upload_url = `/api/shipment_lists/upload_trip.php`;
    const form = this.uploadFileForm.value;
    Object.keys(form).forEach((key) => {
      if (key !== 'fileInput') {
        this.formData.append(key, form[key]);
      }
    });
    console.log('UPLOAD TRIP FormData: ', this.formData);
    this.showSpinner = true;

    return this.http.post<any>(upload_url, this.formData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Uploaded the ASN File successfully.'); 
        setTimeout(() => {
          this.showSpinner = false;
          this.closeModal();
          window.location.reload(); 
        }, 2000)
      })
  }

  submitYoshinoFile() {
    console.log('UPLOAD YOSHINO');

    const upload_url = `/api/shipment_lists/upload_yoshino.php`;
    const form = this.uploadYoshinoForm.value;
    Object.keys(form).forEach((key) => {
      if (key !== 'fileInput') {
        this.formData.append(key, form[key]);
      }
    });
    console.log('UPLOAD YOSHINO FormData: ', this.formData);
    this.showSpinner = true;

    return this.http.post<any>(upload_url, this.formData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Uploaded the YOSHINO File successfully.'); 
        setTimeout(() => {
          this.showSpinner = false;
          this.closeModal();
          window.location.reload(); 
        }, 2000)
      })
  }

  submitInventoryFile() {
    //const upload_url = `/api/work_orders/newams_upload_trip.php`;
    // Temporary   
    const upload_url = `/api/inventory/inventory_upload_file.php`;
    const form = this.uploadInventoryFileForm.value;
    Object.keys(form).forEach((key) => {
      if (key !== 'fileInput') {
        this.formData.append(key, form[key]);
      }
    });

    return this.http.post<any>(upload_url, this.formData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = true;
        setTimeout(() => {
          this.showSpinner = false;
          this.closeModal();
        }, 2000)
      })
  }


  moveExceptionCarton() {
    const edit_shipment_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=REDIRECT_BARCODE`;

    const shipmentObj = this.moveExceptionCartonForm.value;

    var postData = {
      ...shipmentObj
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(edit_shipment_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
          this.toastr.success('You Moved an Exception Carton successfully.'); 
          this.closeModal();
      })
  }

  private bolPrinting = false;

  printBOL() {
    if (this.bolPrinting) return;
    const data = this.printBOLForm.value;
    const preview = window.open('', '_blank');
    if (!preview) {
      this.toastr.error('Allow pop-ups for AMS, then click Print again.');
      return;
    }
    this.bolPrinting = true;
    const doc = preview.document;
    doc.title = 'Bill of Lading ' + (data.alternate_reference || '');
    doc.body.style.cssText = 'margin:0;font:16px Arial,sans-serif;background:#eef1f5';
    const bar = doc.createElement('div');
    bar.style.cssText = 'padding:12px;display:flex;align-items:center;gap:16px';
    const button = doc.createElement('button');
    button.textContent = 'Print Bill of Lading';
    button.disabled = true;
    button.style.cssText = 'padding:10px 16px;cursor:pointer';
    const status = doc.createElement('span');
    status.textContent = 'Preparing bill of lading…';
    bar.append(button, status);
    const frame = doc.createElement('iframe');
    frame.title = 'Bill of Lading';
    frame.style.cssText = 'display:block;border:0;width:100%;height:calc(100vh - 65px)';
    doc.body.append(bar, frame);
    let objectUrl = '';
    let closedTimer: number | undefined;
    const cleanup = () => {
      if (objectUrl) { window.URL.revokeObjectURL(objectUrl); objectUrl = ''; }
      if (closedTimer) window.clearInterval(closedTimer);
    };
    const fail = () => {
      this.bolPrinting = false;
      cleanup();
      if (!preview.closed) status.textContent = 'Unable to prepare this bill of lading. Return to AMS and try again.';
      this.toastr.error('Bill of lading could not be generated. Please try again.');
    };
    const print = () => {
      if (preview.closed || !frame.contentWindow) return;
      try { frame.contentWindow.focus(); frame.contentWindow.print(); }
      catch (_) { status.textContent = 'Use the PDF viewer’s print button below.'; }
    };
    button.onclick = print;
    this.http.get('/api/work_orders/print_pdfs/newams_print_bol.php', {
      responseType: 'blob',
      params: { uuid: data.uuid, shipper_contact_uuid: data.shipper_contact_uuid, page_no: data.page_no }
    }).subscribe({
      next: async (blob) => {
        try {
          if (await blob.slice(0, 5).text() !== '%PDF-') { fail(); return; }
          this.bolPrinting = false;
          if (preview.closed) return;
          objectUrl = window.URL.createObjectURL(blob);
          frame.onload = () => {
            button.disabled = false;
            status.textContent = 'If the print dialog does not open, click Print Bill of Lading.';
            preview.setTimeout(print, 300);
          };
          frame.src = objectUrl;
          closedTimer = window.setInterval(() => { if (preview.closed) cleanup(); }, 1000);
          this.closeModal();
        } catch (_) { fail(); }
      },
      error: fail
    });
  }

  submitCreateEDIFile() {
    const accessToken = localStorage.getItem('access_token');
    const form = this.createEDIFileForm.value;
    const lading_uuid = form['lading_uuid'];
    const create_file_url = `/api/work_orders/create_EDI_file.php?lading_uuid=${lading_uuid}&token=${accessToken}`;

    console.log('Post Data:', form);
    this.showSpinner = true;
    window.open(create_file_url, "_blank")    
    this.closeModal();
  }

  closeModal() {
    console.log('Close Modal: ');
    this.dialogRef.close();
    this.modalService.closeModal();
  }
}
